import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpHeader } from 'src/app/shared/helpers/http-header';
import { environment } from 'src/environments/environment';
import { Helper } from '../helpers/helper.service';
import { Phone } from '../models/phone';

const TOKEN = 'JBR-BH4-4EA-N8K-V8R-OOP-C5H-HOJ';
@Injectable({
  providedIn: 'root',
})
export class PhoneService {

  /**
    * Url for request
    * @var string
    **/
  PhoneUrl: string;

  /**
   * Request Headers
   * @var Headers
   */
  private readonly headers: HttpHeaders;

  /**
   * constructor
   * @param http
   * @param helper
   */
  constructor(
    private readonly http: HttpClient,
    private readonly helper: Helper,
  ) {
    this.PhoneUrl = environment.phones_api_url;
    this.headers = HttpHeader.getHeaders();
  }

  /**
  * Find all phone
  */
  public findAll(): Observable<Phone[]> {
    console.log('get the list of all Phones ' + this.PhoneUrl);
    return this.http.get<Phone[]>(`${this.PhoneUrl}/`, { headers: this.headers });
  }

  /**
  * Find phone by id
  */
  public findById(id: number): Observable<Phone> {
    console.log('get the phone by ID : ' + id);
    return this.http.get<Phone>(`${this.PhoneUrl}/${id}`, { headers: this.headers });
  }

  /**
  * Find phone by id
  */
  public findByTrackNumber(trackNumber: string): Observable<Phone> {
    console.log('get the phone by track number : ' + trackNumber);
    return this.http.get<Phone>(`${this.PhoneUrl}/track/${trackNumber}`, { headers: this.headers });
  }

  /**
     * Save a new Phone
     */
  public save(phone: Phone): Observable<Phone> {
    this.helper.trace(`adding new Phone : ${phone.model}`);
    return this.http.post<Phone>(`${this.PhoneUrl}/`, phone, { headers: this.headers });
  }

  /**
   * update the Phone
   */
  public update(phone: Phone): Observable<Phone> {
    this.helper.trace(`updating : ${phone.model}`);
    let RequestParams: HttpParams = new HttpParams();
    RequestParams = RequestParams.append('id', phone.id.toString());
    return this.http.put<Phone>(`${this.PhoneUrl}/${phone.id}`, phone, { headers: this.headers });
  }

  /**
  * delete an Phone
  */
  public delete(phone: Phone): Observable<Phone> {
    this.helper.trace(`deleting : ${phone.id}`);
    return this.http.delete<Phone>(`${this.PhoneUrl}/${phone.id}`, { headers: this.headers });
  }

  public checkImei(imei: string) {
    const params = new HttpParams({
      fromObject: { 'service': 0, 'imei': imei, 'key': TOKEN }
    });
    const options = { headers: this.headers, params: params, reportProgress: true };
    return this.http.get('https://api.ifreeicloud.co.uk', options);
  }
}